import {Component, Input} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ErrorTemplate} from '../../../models/ErrorTemplate';

@Component({
  selector: 'achoo-validation-alerts',
  templateUrl: './achoo-validation-alerts.component.html',
  styleUrls: ['./achoo-validation-alerts.component.scss']
})
export class AchooValidationAlertsComponent {

  @Input()
  component: AchooInputComponent<any>;

  get errorMessages() {
    return this.component.errors;
  }

  getMessage(error: ErrorTemplate): string {
    return error.message;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-validation-alerts/achoo-validation-alerts.component.ts